import React, { useState } from "react";
import {
  Body,
  Container,
  Wrapper,
  CollapseToggle,
  MenuItem,
} from "../style/view.styles";
import UserProfileSection from "../components/Elements/UserProfileSection";
import UserApplicationsSection from "../components/Elements/UserApplicationsSection";
import UserConversations from "../components/Elements/UserConversations";
import UserDocumentsSection from "../components/Elements/UserDocumentsSection";
import { logoutUser } from "../utils/AuthHandler";
import { useLocation } from "react-router-dom";
import EmptyState from "../components/Elements/EmptyState";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Sidebar, SidebarHeader } from "../style/sidebar.styles";

export default function MyProfile() {
  const location = useLocation();
  const { userProfileMenu, messageReceiver, initialMessage } =
    location.state || {};

  const [activeMenuItem, setActiveMenuItem] = useState(
    userProfileMenu || "Profile"
  );
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const handleMenuClick = (menuItem) => {
    setActiveMenuItem(menuItem);
    if (window.innerWidth <= 960) {
      setIsSidebarExpanded(false);
    }
  };

  const renderContent = () => {
    switch (activeMenuItem) {
      case "Profile":
        return <UserProfileSection />;
      case "Applications":
        return <UserApplicationsSection />;
      case "Conversations":
        return (
          <UserConversations
            receiver={messageReceiver}
            message={initialMessage}
          />
        );
      case "Documents":
        return <UserDocumentsSection />;
      case "Logout":
        logoutUser();
        break;
      default:
        return <EmptyState message="Select a menu item to view content." />;
    }
  };

  return (
    <Wrapper className="paleBlueGreyBg">
      <Container>
        <Sidebar style={{ width: "30%" }} expanded={isSidebarExpanded}>
          <SidebarHeader>
            <span>{activeMenuItem}</span>
            <CollapseToggle
              onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
            >
              {isSidebarExpanded ? <FaChevronUp /> : <FaChevronDown />}
            </CollapseToggle>
          </SidebarHeader>

          {(isSidebarExpanded || window.innerWidth > 960) && (
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {[
                "Profile",
                "Documents",
                "Applications",
                "Conversations",
                "Logout",
              ].map((item) => (
                <MenuItem
                  key={item}
                  active={activeMenuItem === item}
                  onClick={() => handleMenuClick(item)}
                >
                  {item}
                </MenuItem>
              ))}
            </ul>
          )}
        </Sidebar>

        <Body style={{ margin: "0px", width: "100%" }}>{renderContent()}</Body>
      </Container>
    </Wrapper>
  );
}
